// Imports
import React, { useEffect, useState } from 'react';
import Link from "../menu-link/LinkHelper";
import { l, getLang } from '../../lang';
import { supabase } from '../../utils/supabase.js';

export default function PageNotFound()
{
    const lang = getLang();
    const [contentMap, setContentMap] = useState(null);

    useEffect(() => {
        supabase.from('not_found_content').select('key, fr, en')
            .then(({ data }) => {
                if (data) {
                    const map = {};
                    data.forEach(r => { map[r.key] = { fr: r.fr, en: r.en }; });
                    setContentMap(map);
                }
            });
    }, []);

    const t = (key) => contentMap?.[key]?.[lang] || l(key, lang);

    return (<>
        <div className="section section-page-not-found">
            <div className="section-page-not-found-inner">
                <h1 className="not-found-title">404</h1>
                <p className="paragraph big-text">{t('404-content')}</p>
                <Link className='button' href="/">
                    <span>{t('404-btn')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                    </svg>
                </Link>
            </div>
        </div>
    </>)
}
